import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import Slide from 'react-reveal/Slide'
import classnames from 'classnames'

import { ModalContext } from 'hooks/useModals'

import { digObject } from 'functions/utilities'

import Button from './Button'
import Campaign from './Campaign'
import Content from './Content'
import ExpandableSection from './ExpandableSection'
import Footer from './Footer'
import Header from './Header'
import RenderController from './RenderController'
import SelectItem from './SelectItem'
import Separator from './Separator'
import SubHeader from './SubHeader'
import User from './User'

import styles from './styles.scss'

function preventBubble(e){
  e.stopPropagation()
}

const SidebarModal = (props) => {
  const {
    callbacks: { closeModal }, children, modalKey, showModal, size,
  } = props

  // You can use ModalContext on a page when you want to keep
  // track of open modals for layering purposes

  const modalContext = useContext(ModalContext)
  const { openModalKeys, baseModalKey, topModalKey } = modalContext

  useEffect(() => {
    const registerModalFn = digObject(modalContext, 'callbacks.registerModal')

    if (modalKey && registerModalFn){
      registerModalFn(modalKey, showModal)
    }

    return () => {
      if (registerModalFn) registerModalFn(modalKey, false)
    }
  }, [modalKey, showModal])

  const isBaseModal = baseModalKey ? baseModalKey === modalKey : true
  const isTopModal = topModalKey ? topModalKey === modalKey : true
  const modalIndex = openModalKeys ? openModalKeys.indexOf(modalKey) : 0

  if (!showModal){
    return null
  }

  return (
    <div
      className={classnames(styles.root, styles[size], isBaseModal ? styles.baseModal : null)}
      data-test-id="sidebarModal"
      onClick={() => (isTopModal ? closeModal() : null)}
      style={{ zIndex: !isBaseModal ? 999 + modalIndex : null }}
    >
      <Slide duration={300} right>
        <div className={styles.container} display="block" onClick={preventBubble}>
          <div>{children}</div>
        </div>
      </Slide>
    </div>
  )
}

SidebarModal.propTypes = {
  callbacks: PropTypes.shape({
    closeModal: PropTypes.func,
  }),
  children: PropTypes.node,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'large']),
}

SidebarModal.defaultProps = {
  callbacks: {},
  size: 'small',
}

SidebarModal.Button = Button
SidebarModal.Campaign = Campaign
SidebarModal.Content = Content
SidebarModal.ExpandableSection = ExpandableSection
SidebarModal.Footer = Footer
SidebarModal.Header = Header
SidebarModal.RenderController = RenderController
SidebarModal.SelectItem = SelectItem
SidebarModal.Separator = Separator
SidebarModal.SubHeader = SubHeader
SidebarModal.User = User

export default SidebarModal
